module.exports = __webpack_public_path__ + "static/media/aojiabao.06938f5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/aojiabao.mp4
// module id = UkYb
// module chunks = 0